export default {
  REGISTER_ITEMS_GROUP: '@WS_EDITOR/CONTEXT_MENU/REGISTER_ITEMS_GROUP',
  SET_VISIBILITY_STATUS: '@WS_EDITOR/CONTEXT_MENU/SET_VISIBILITY_STATUS',
  HIDE_CONTEXT_MENU: '@WS_EDITOR/CONTEXT_MENU/HIDE_CONTEXT_MENU',
  SHOW_CONTEXT_MENU: '@WS_EDITOR/CONTEXT_MENU/SHOW_CONTEXT_MENU',
};
